import { Avatar, Box, Typography } from '@mui/material';
import ToolTip from '../../../../../components/ToolTip/ToolTip';

export const columns = [
  {
    field: 'student_name',
    headerName: 'Student',
    width: 300,
    renderCell: ({ value, row }) => {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Avatar
            src={`${process.env.REACT_APP_API_URL}uploads/${row?.profile_image}`}
            sx={{
              width: 45,
              height: 45,
            }}
          />
          <Typography
            variant="body2"
            sx={{
              textTransform: 'lowercase',
              ':first-letter': {
                textTransform: 'uppercase',
              },
            }}
          >
            {value}
          </Typography>
        </Box>
      );
    },
  },
  { field: 'admn_no', headerName: 'Adm No', width: 120 },
  { field: 'subject_name', headerName: 'Subject', width: 200 },
  { field: 'cro_name', headerName: 'CRO Name', width: 300 },
  {
    field: 'course_name',
    headerName: 'Course',
    width: 200,
    renderCell: ({ value }) => <ToolTip content={value} expand={value} />,
  },
  { field: 'completed_sessions', headerName: 'Completed Sessions', width: 200 },
  ...Array.from({ length: 8 }).map((_, i) => ({
    field: `exm${i + 1}Avg`,
    headerName: `Exam ${i + 1}`,
    width: 120,
    valueGetter: ({ value }) => (value !== null && value !== undefined ? `${value}%` : '-'),
  })),
  { field: 'preAvg', headerName: 'Pre', width: 120, valueGetter: ({ value }) => `${value}%` },
  { field: 'postAvg', headerName: 'Post', width: 120, valueGetter: ({ value }) => `${value}%` },
];
